// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CaretRightFilledSvg from "@fishx/icons-svg/es/asn/CaretRightFilled";
import FishxIcon from '../components/FishxIcon';

var CaretRightFilled = function CaretRightFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CaretRightFilledSvg
  }));
};

CaretRightFilled.displayName = 'CaretRightFilled';
export default React.forwardRef(CaretRightFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CaretRightFilled.js
// module id = 2169
// module chunks = 0